import './scss/artworks-bulk-import.scss';
import { fUploader } from '../fUploader';
import { appConfig as $config } from "../../app.config";
import { Common } from "../Common";
import { UI } from "../UI";

const initialFilesState = {
  zip: {
    added: false,
    link: ''
  },
  excel: {
    added: false,
    link: ''
  }
};

export const ArtworksBulkImport = (function () {
  let dialogInstance;
  let $fup;
  let $uploadBtn;
  let files = { ...initialFilesState };

  let callback = () => null;

  const dialog = (cb) => {
    close();
    let template = require('./tmpl/artworks-bulk-import.hbs');

    callback = (links) => {
      if (typeof cb === 'function') {
        cb(links);
      }
    }

    dialogInstance = bootbox
      .dialog({
        title: $lang.artwork.ImportArtwork,
        message: template({ $lang: $Lang }),
        size: 'xl',
        className: 'modal-scrolled-content assets-manager-addfile',
        buttons: {
          Ok: {
            label: `${$lang.btn.upload}`,
            className: 'btn btn-primary btn-artworksBulkImport',
            callback: importArtworks
          },
          Close: {
            label: `${$lang.btn.cancel}`,
            className: 'btn btn-link font-weight-bold'
          }
        }
      });

    dialogInstance.init(dialogInit);
  };

  const close = () => {
    if (!dialogInstance) {
      return;
    }

    dialogInstance.modal('hide');
    dialogInstance = null;
  };

  const show = () => {
    if (!dialogInstance) {
      return;
    }

    $('.assets-manager-addfile.bootbox').show();
    $('.modal-backdrop').show();

    UI.unblock('.assets-manager-addfile .modal-content');
  };

  const hide = () => {
    if (!dialogInstance) {
      return;
    }

    $('.assets-manager-addfile.bootbox').hide();
    $('.modal-backdrop').hide();
  };

  const setTemplateError = (errorMessage) => {
    hideErrors();
    $('#import-error-template .import-error__bold').text(errorMessage);
    $('#import-error-template').removeClass('hidden');
  };

  const setZipError = (errorMessage) => {
    hideErrors();
    $('#import-error-zip .import-error__bold').text(errorMessage);
    $('#import-error-zip').removeClass('hidden');
  };

  const dialogInit = () => {
    $uploadBtn = $('.btn-artworksBulkImport');
    $uploadBtn.prop('disabled', true);

    $fup = null;
    files = { ...initialFilesState };

    downloadTemplateInit();
    fupInit();

    $('.import-error').off().on('click', hideErrors)
  };

  const downloadTemplateInit = () => {
    // Download Templates
    $('#artworksBulkImport .link-with-icon').off().on('click', (e) => {
      if (e.target?.classList?.contains('downloadExcelTemplate')) {
        Common.saveFile(
          $config.apiURL + $config.fileTemplates.artworksBulkImport.template.link,
          $config.fileTemplates.artworksBulkImport.template.name
        );

        return;
      }

      if (e.target?.classList?.contains('downloadExcelTutorial')) {
        Common.saveFile(
          $config.apiURL + $config.fileTemplates.artworksBulkImport.tutorial.link,
          $config.fileTemplates.artworksBulkImport.tutorial.name
        );

        return;
      }
    });
  };

  const fupInit = () => {
    const zipFup = new fUploader('#artworksBulkImport input.zipArtworks', {
      extensions: ['zip'],
      blockEl: '#artworksBulkImport input.zipArtworks',
      validate: validate.bind(null, 'zip'),
      complete: complete.bind(null, 'zip')
    });

    const excelFup = new fUploader('#artworksBulkImport input.excelFile', {
      extensions: ['xlsx'],
      blockEl: '#artworksBulkImport input.excelFile',
      validate: validate.bind(null, 'excel'),
      complete: complete.bind(null, 'excel')
    });

    $fup = [zipFup, excelFup];
  };

  const hideErrors = (fileType) => {
    if (!fileType) {
      $('.import-error').addClass('hidden');
      return;
    }

    switch (fileType) {
      case 'zip':
        $('#import-error-zip').addClass('hidden');
        break;
      case 'excel':
        $('#import-error-template').addClass('hidden');
        break;
    }
  }

  const validate = (fileType, data) => {
    files[fileType] = {
      ...files[fileType],
      added: !!data,
      link: null
    };

    $uploadBtn.prop('disabled', !files.zip.added || !files.excel.added);
    hideErrors(fileType);
  };

  const complete = (fileType, data) => {
    files[fileType] = {
      ...files[fileType],
      link: data[0]?.uri
    };

    if (!files.zip.link || !files.excel.link) {
      return;
    }

    callback({
      fileUrl: files.excel.link,
      zipFileUrl: files.zip.link
    });
  };

  const uploadStart = () => {
    if (!Array.isArray($fup)) {
      return;
    }

    $fup.forEach((fup) => {
      fup.uploadStart();
    });
  };

  const importArtworks = () => {
    UI.block('.assets-manager-addfile .modal-content');

    if (files.excel.link && files.zip.link) {
      callback({
        fileUrl: files.excel.link,
        zipFileUrl: files.zip.link
      });

      return false;
    }

    uploadStart();
    return false;
  };

  return {
    dialog,
    close,
    show,
    hide,
    setTemplateError,
    setZipError
  };
})();
